import { render, staticRenderFns } from "./BcLogin.vue?vue&type=template&id=cdc3c1a4&scoped=true&"
import script from "./BcLogin.vue?vue&type=script&lang=js&"
export * from "./BcLogin.vue?vue&type=script&lang=js&"
import style0 from "./BcLogin.vue?vue&type=style&index=0&id=cdc3c1a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc3c1a4",
  null
  
)

export default component.exports